import {
    httpStoreProjectSocialWelfareConditions,
    HttpStoreProjectSocialWelfareConditionsPayload
} from '@/features/projects/http/projects.http'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const useStoreSocialWelfareConditions = (
    urlParams: {projectId: string},
    options?: UseMutationOptions<unknown, AxiosError<ErrorResponseData>, HttpStoreProjectSocialWelfareConditionsPayload>
) => {
    return useMutation({
        ...options,
        mutationFn: (payload: HttpStoreProjectSocialWelfareConditionsPayload) =>
            httpStoreProjectSocialWelfareConditions({urlParams, payload})
    })
}
